import { getAppInstance } from '/@/store/session/selectors';

export const getAskAnExpertEnabled = (state) => {
    return getAppInstance(state).enableAskAnExpert;
};
